import { useEffect, useState } from 'react';
import { publicApi } from '../lib/api';

export const useSiteData = (key) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const fetcher = {
      packages: publicApi.getPackages,
      services: publicApi.getServices,
      gallery: publicApi.getGallery,
      testimonials: publicApi.getTestimonials,
      faqs: publicApi.getFaqs,
      settings: publicApi.getSettings,
    }[key];

    if (!fetcher) {
      setLoading(false);
      return;
    }

    fetcher()
      .then((d) => mounted && setData(d))
      .catch(() => mounted && setData(null))
      .finally(() => mounted && setLoading(false));

    return () => {
      mounted = false;
    };
  }, [key]);

  return { data, loading };
};
